module.exports = __webpack_public_path__ + "static/img/tx_5.eab6cf47.png";